export const KEYS = {
  VALUE_PLACEHOLDER: '-',
};
